import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LuSearch as FiSearch,
  LuArrowUpRight as FiArrowUpRight,
  LuStore as CiShop,
} from "react-icons/lu";
import { platformHost } from "../../../functions/platformHost";
import {
  setConfigurationSearch,
  setDiscountSearch,
  setClientSearch,
  setAttributeSearch,
  setCategorySearch,
  setCatalogSearch,
  setChannelSearch,
  setCartSearch,
  setOrderSearch,
} from "../../../reducers/userConfigSlice";
import { adminSections } from "../navigation";
import "./style.css";

export const AdminBar = () => {
  const subdomain = useSelector(
    (state) =>
      state.aplicationConfig?.corporationData?.corporationOwner?.corporationData
        ?.subdomain,
  );
  const shopHost =
    typeof subdomain === "string" && subdomain.trim()
      ? platformHost(subdomain.trim(), "shop")
      : null;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current =
    adminSections.find((section) => pathname.split("/")[1] === section.path) ||
    adminSections[0];
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const isChannels = current.path === "salesChannel";
  const isCarts = current.path === "carts";
  const cartSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.cartSearch || "",
  );
  const isOrders = current.path === "orders";
  const isCatalogs = current.path === "catalogs";
  const isCategories = current.path === "categories";
  const isConfiguration = current.path === "configuration";
  const configurationSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.configurationSearch || "",
  );
  const isDiscounts = current.path === "discounts";
  const discountSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.discountSearch || "",
  );
  const isClients = current.path === "clients";
  const clientSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.clientSearch || "",
  );
  const isAttributes = current.path === "attributes";
  const attributeSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.attributeSearch || "",
  );
  const isContextual =
    isChannels ||
    isOrders ||
    isCarts ||
    isCatalogs ||
    isCategories ||
    isAttributes ||
    isClients ||
    isDiscounts ||
    isConfiguration;
  const categorySearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.categorySearch || "",
  );
  const catalogSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.catalogSearch || "",
  );
  const orderSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.orderSearch || "",
  );
  const setContextSearch = (value) =>
    dispatch(
      isCarts
        ? setCartSearch(value)
        : isConfiguration
          ? setConfigurationSearch(value)
          : isDiscounts
            ? setDiscountSearch(value)
            : isClients
              ? setClientSearch(value)
              : isAttributes
                ? setAttributeSearch(value)
                : isCategories
                  ? setCategorySearch(value)
                  : isCatalogs
                    ? setCatalogSearch(value)
                    : isOrders
                      ? setOrderSearch(value)
                      : setChannelSearch(value),
    );
  const channelSearch = useSelector(
    (state) => state.aplicationConfig.userConfig?.channelSearch || "",
  );
  const contextSearch = isCarts
    ? cartSearch
    : isConfiguration
      ? configurationSearch
      : isDiscounts
        ? discountSearch
        : isClients
          ? clientSearch
          : isAttributes
            ? attributeSearch
            : isCategories
              ? categorySearch
              : isCatalogs
                ? catalogSearch
                : isOrders
                  ? orderSearch
                  : channelSearch;
  const matches = adminSections.filter((section) =>
    section.name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .includes(
        search
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase(),
      ),
  );
  const go = (path) => {
    setSearch("");
    navigate("/" + path);
  };
  return (
    <header className="adminBar desktop adminTopbar">
      <div className="adminTopbarNavigation">
        <label className="visually-hidden" htmlFor="admin-section-switch">
          Ir a una sección
        </label>
        <select
          id="admin-section-switch"
          value={current.path}
          onChange={(event) => go(event.target.value)}
        >
          {adminSections.map((section) => (
            <option key={section.path} value={section.path}>
              {section.name}
            </option>
          ))}
        </select>
        <form
          className="adminQuickSearch"
          role="search"
          onSubmit={(event) => {
            event.preventDefault();
            if (!isContextual && search.trim() && matches.length === 1)
              go(matches[0].path);
          }}
        >
          <FiSearch aria-hidden="true" />
          <input
            type="search"
            aria-label={
              isConfiguration
                ? "Buscar en configuración"
                : isDiscounts
                  ? "Buscar en descuentos"
                  : isClients
                    ? "Buscar en clientes"
                    : isAttributes
                      ? "Buscar en atributos"
                      : isCategories
                        ? "Buscar en categorías"
                        : isCatalogs
                          ? "Buscar en catálogos"
                          : isOrders
                            ? "Buscar en pedidos"
                            : isCarts
                              ? "Buscar en carritos"
                              : isChannels
                                ? "Buscar en canal de venta"
                                : "Buscar secciones"
            }
            placeholder={
              isConfiguration
                ? "Buscar en configuración…"
                : isDiscounts
                  ? "Buscar en descuentos…"
                  : isClients
                    ? "Buscar en clientes…"
                    : isAttributes
                      ? "Buscar en atributos…"
                      : isCategories
                        ? "Buscar en categorías…"
                        : isCatalogs
                          ? "Buscar en catálogos…"
                          : isOrders
                            ? "Buscar en pedidos…"
                            : isCarts
                              ? "Buscar en carritos…"
                              : isChannels
                                ? "Buscar en canal de venta…"
                                : "Buscar una sección…"
            }
            onKeyDown={(event) => {
              if (event.key === "Escape") {
                event.preventDefault();
                isContextual ? setContextSearch("") : setSearch("");
              }
            }}
            value={isContextual ? contextSearch : search}
            onChange={(event) =>
              isContextual
                ? setContextSearch(event.target.value)
                : setSearch(event.target.value)
            }
          />
          {!isContextual && search.trim() && (
            <div
              className="adminQuickSearchResults"
              aria-label="Secciones encontradas"
            >
              {matches.length ? (
                matches.map((section) => (
                  <Link
                    key={section.path}
                    to={"/" + section.path}
                    onClick={() => setSearch("")}
                  >
                    <span>
                      <strong>{section.name}</strong>
                      <small>{section.description}</small>
                    </span>
                    <FiArrowUpRight aria-hidden="true" />
                  </Link>
                ))
              ) : (
                <p role="status">No hay secciones con ese nombre.</p>
              )}
            </div>
          )}
        </form>
      </div>
      <div className="goToShop" hidden={isContextual}>
        {shopHost ? (
          <a href={`https://${shopHost}`} rel="noreferrer" target="_blank">
            <CiShop aria-hidden="true" /> Ver tienda{" "}
            <FiArrowUpRight aria-hidden="true" />
          </a>
        ) : (
          <span role="status">Esperando dominio de tienda…</span>
        )}
      </div>
    </header>
  );
};
